import Icon from "components/Icon";
import React, { useState ,useEffect, useRef} from 'react';

const attachButtons = [
	{ icon: "attachRooms", label: "Choose room" },
	{ icon: "attachContacts", label: "Choose contact" },
	{ icon: "attachDocument", label: "Choose document" },
	{ icon: "attachCamera", label: "Use camera" },
	{ icon: "attachImage", label: "Choose image" },
];



const ChatInput = ({
	showAttach,
	setShowAttach,
	showEmojis,
	setShowEmojis,
	newMessage,
	setNewMessage,
	submitNewMessage,
	newFileMessage,
	setNewFileMessage,
	submitNewFileMessage,
}) => {

	const [selectedFile, setSelectedFile] = useState(null);
	const textareaRef = useRef(null);

  // Auto resize textarea
	useEffect(() => {
		textareaRef.current.style.height = 'auto';
		textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`;
	}, [newMessage]);

	const handleIconClick = (icon) => {
		let input;
		  switch(icon) {
			  case 'attachImage':
				//   console.log("Attach image clicked")
				  input = document.createElement('input');
				  input.type = 'file';
				  input.addEventListener('change', handleFileSelect);
				  input.click();
			  break;
				case 'attachDocument':
				// console.log("Attach document clicked")
				input = document.createElement('input');
				input.type = 'file';
				input.addEventListener('change', handleFileSelect);
				input.click();
				
			  break;
			  default:
				console.log("Not supported")
			}
	};
  
	const handleFileSelect = (event) => {
		// console.log('File event', event)
	  	setSelectedFile(event.target.files[0]);
		setNewFileMessage(event.target.files[0])
		//handleFileUpload()
		submitNewFileMessage(event.target.files[0])
		setShowAttach(false)
	};


	const detectEnterPress = (e) => {
		if (e.key === "Enter" && e.ctrlKey) {
		  e.preventDefault();
		  // Submit the message when Ctrl + Enter is pressed
		  
		  setNewMessage(prevMessage => prevMessage + "\n");
		}
		else if (e.key === "Enter") {
		  e.preventDefault();
		  // Add a new line when just Enter is pressed
		  submitNewMessage();
		}
	  };


	  
	return (
		<div className="chat__input-wrapper">
			{showEmojis && (
				<button aria-label="Close emojis" onClick={() => setShowEmojis(false)}>
					<Icon id="cancel" className="chat__input-icon" />
				</button>
			)}
			<button aria-label="Emojis" onClick={() => setShowEmojis(true)}>
				<Icon
					id="smiley"
					className={`chat__input-icon ${
						showEmojis ? "chat__input-icon--highlight" : ""
					}`}
				/>
			</button>
			{showEmojis && (
				<>
					<button aria-label="Choose GIF">
						<Icon id="gif" className="chat__input-icon" />
					</button>
					<button aria-label="Choose sticker">
						<Icon id="sticker" className="chat__input-icon" />
					</button>
				</>
			)}
			<div className="pos-rel">
				<button aria-label="Attach" onClick={() => setShowAttach(!showAttach) }>
					<Icon
						id="attach"
						className={`chat__input-icon ${
							showAttach ? "chat__input-icon--pressed" : ""
						}`}
					/>
				</button>

				<div
					className={`chat__attach ${showAttach ? "chat__attach--active" : ""}`}
				>
					{attachButtons.map((btn) => (
						<button
							className="chat__attach-btn"
							aria-label={btn.label}
							key={btn.label}
						>
							<Icon id={btn.icon} className="chat__attach-icon" onClick={() => handleIconClick(btn.icon) } />
						</button>
					))}

				</div>
			</div>
			{/* <input
				className="chat__input"
				placeholder="... הקלד\י הודעה"
				value={newMessage}
				onChange={(e) => setNewMessage(e.target.value)} 
				onKeyDown={detectEnterPress}
				dir="rtl"	
  				lang="he"		
			/> */}
			<textarea
				ref={textareaRef}
				className="chat__input"
				placeholder="הקלד\י הודעה ...."
				value={newMessage}
				onChange={(e) => setNewMessage(e.target.value)} 
				onKeyDown={detectEnterPress}
				dir="rtl" 
				lang="he"     
			/>
			{newMessage ? (
				<button aria-label="Send message" onClick={submitNewMessage}>
					<Icon id="send" className="chat__input-icon" />
				</button>
			) : (
				<button aria-label="Record voice note">
					<Icon id="microphone" className="chat__input-icon" />
				</button>
			)}
		</div>
	);
};



export default ChatInput;
